import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-compass-3-line text-4xl"></i>
      </span>
      <h1 className="mt-6 text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被移除，返回首页继续探索热门网站吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/about"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          了解本站
        </Link>
      </div>
    </div>
  );
}